import type { ICustomerLogo } from '@shared/types';

// Заказчики по госконтрактам (без расторгнутых): одна запись — одна организация.
// kind: logo — собственный знак с официального сайта; coat — герб территории заказчика:
// региональным органам и учреждениям — герб региона, муниципальным — района или городского округа
// места поставки (OSM → Wikidata P94 → Wikimedia Commons; нет герба района — герб региона).
// Файлы без перерисовки: обрезаны поля, WebP. Сгенерировано — руками не править
export const CUSTOMER_LOGOS: readonly ICustomerLogo[] = [
  {
    id: 'c2912000675',
    kind: 'coat',
    name: 'Администрация Коношского района',
    logo: '/customers/coats/q257367.webp',
    width: 130,
    height: 160,
    source:
      'https://commons.wikimedia.org/wiki/File:Coat_of_Arms_of_Konosha_rayon_(Arkhangelsk_oblast).png',
  },
  {
    id: 'c2922001477',
    kind: 'coat',
    name: 'Администрация Устьянского округа',
    logo: '/customers/coats/q2607218.webp',
    width: 131,
    height: 160,
    source:
      'https://commons.wikimedia.org/wiki/File:Coat_of_Arms_of_Ustyansky_rayon_(Arkhangelsk_oblast).png',
  },
  {
    id: 'c2907002204',
    kind: 'coat',
    name: 'Вельская спортивная школа',
    logo: '/customers/coats/q1402861.webp',
    width: 93,
    height: 160,
    source:
      'https://commons.wikimedia.org/wiki/File:Coat_of_Arms_of_Velsk_(Arkhangelsk_oblast).png',
  },
  {
    id: 'c2901198751',
    kind: 'coat',
    name: 'Министерство спорта Архангельской области',
    logo: '/customers/coats/q1875.webp',
    width: 161,
    height: 160,
    source: 'https://commons.wikimedia.org/wiki/File:Coat_of_Arms_of_Arkhangelsk_oblast.svg',
  },
  {
    id: 'sh1-arkhangelsk',
    kind: 'logo',
    name: 'Спортивная школа № 1, Архангельск',
    logo: '/customers/sh1-arkhangelsk.webp',
    width: 170,
    height: 189,
    source: 'http://dussh1-arhcity.ru/',
  },
  {
    id: 'c2904025700',
    kind: 'coat',
    name: 'Управление городского хозяйства, Котлас',
    logo: '/customers/coats/q4307263.webp',
    width: 131,
    height: 160,
    source:
      'https://commons.wikimedia.org/wiki/File:Coat_of_Arms_of_Kotlas_(Arkhangelsk_oblast)_2007.png',
  },
  {
    id: 'c2911002493',
    kind: 'coat',
    name: 'Усачевская средняя школа',
    logo: '/customers/coats/q1807671.webp',
    width: 128,
    height: 160,
    source: 'https://commons.wikimedia.org/wiki/File:Kargopol_coat_of_arms.png',
  },
  {
    id: 'c3120103684',
    kind: 'coat',
    name: 'Купинская территориальная администрация',
    logo: '/customers/coats/q2218609.webp',
    width: 129,
    height: 160,
    source: 'https://commons.wikimedia.org/wiki/File:Lob_Coats_of_arms_Shebekino.svg',
  },
  {
    id: 'c3120104293',
    kind: 'coat',
    name: 'Управление ЖКХ Шебекинского округа',
    logo: '/customers/coats/q2218609.webp',
    width: 129,
    height: 160,
    source: 'https://commons.wikimedia.org/wiki/File:Lob_Coats_of_arms_Shebekino.svg',
  },
  {
    id: 'c3120103726',
    kind: 'coat',
    name: 'Управление городского хозяйства Шебекинского округа',
    logo: '/customers/coats/q2218609.webp',
    width: 129,
    height: 160,
    source: 'https://commons.wikimedia.org/wiki/File:Lob_Coats_of_arms_Shebekino.svg',
  },
  {
    id: 'c3228001582',
    kind: 'coat',
    name: 'Администрация Суземского района',
    logo: '/customers/coats/q2810.webp',
    width: 153,
    height: 160,
    source: 'https://commons.wikimedia.org/wiki/File:Coat_of_Arms_of_Bryansk_Oblast.svg',
  },
  {
    id: 'c3229002363',
    kind: 'coat',
    name: 'Администрация Суражского района',
    logo: '/customers/coats/q2810.webp',
    width: 153,
    height: 160,
    source: 'https://commons.wikimedia.org/wiki/File:Coat_of_Arms_of_Bryansk_Oblast.svg',
  },
  {
    id: 'c3203004687',
    kind: 'coat',
    name: 'Ардонская средняя школа им. М. Н. Плоткина',
    logo: '/customers/coats/q4223943.webp',
    width: 127,
    height: 160,
    source: 'https://commons.wikimedia.org/wiki/File:Герб_города_Клинцы.jpg',
  },
  {
    id: 'c3249001576',
    kind: 'coat',
    name: 'Лопандинская сельская администрация',
    logo: '/customers/coats/q2708373.webp',
    width: 128,
    height: 160,
    source:
      'https://commons.wikimedia.org/wiki/File:Coat_of_arms_of_Komarichi_rayon_(Bryansk_Oblast).png',
  },
  {
    id: 'c3243001298',
    kind: 'coat',
    name: 'Мирнинская сельская администрация',
    logo: '/customers/coats/q2708368.webp',
    width: 127,
    height: 160,
    source: 'https://commons.wikimedia.org/wiki/File:Герб_Клетнянского_района.png',
  },
  {
    id: 'c3245002392',
    kind: 'coat',
    name: 'Мичуринская сельская администрация',
    logo: '/customers/coats/q2534488.webp',
    width: 117,
    height: 160,
    source: 'https://commons.wikimedia.org/wiki/File:RUS_Брянский_район_COA.gif',
  },
  {
    id: 'c3253001057',
    kind: 'coat',
    name: 'Найтоповичская сельская администрация',
    logo: '/customers/coats/q2810.webp',
    width: 153,
    height: 160,
    source: 'https://commons.wikimedia.org/wiki/File:Coat_of_Arms_of_Bryansk_Oblast.svg',
  },
  {
    id: 'c3253001748',
    kind: 'coat',
    name: 'Овчинская сельская администрация',
    logo: '/customers/coats/q2810.webp',
    width: 153,
    height: 160,
    source: 'https://commons.wikimedia.org/wiki/File:Coat_of_Arms_of_Bryansk_Oblast.svg',
  },
  {
    id: 'c3241003317',
    kind: 'coat',
    name: 'Первомайская сельская администрация',
    logo: '/customers/coats/q2737400.webp',
    width: 127,
    height: 160,
    source:
      'https://commons.wikimedia.org/wiki/File:Coat_of_arms_of_the_Klintsovsky_municipal_district_of_the_Bryansk_region.jpg',
  },
  {
    id: 'c3202009989',
    kind: 'coat',
    name: 'Слободищенская сельская администрация',
    logo: '/customers/coats/q2737405.webp',
    width: 129,
    height: 160,
    source: 'https://commons.wikimedia.org/wiki/File:Dyatkovsky_rayon_COA_(2019).gif',
  },
  {
    id: 'c3234047345',
    kind: 'coat',
    name: 'Управление капитального строительства Брянской области',
    logo: '/customers/coats/q2810.webp',
    width: 153,
    height: 160,
    source: 'https://commons.wikimedia.org/wiki/File:Coat_of_Arms_of_Bryansk_Oblast.svg',
  },
  {
    id: 'c3322001607',
    kind: 'coat',
    name: 'Администрация Селивановского района',
    logo: '/customers/coats/q1654438.webp',
    width: 127,
    height: 160,
    source:
      'https://commons.wikimedia.org/wiki/File:Coats_of_arms_of_Selivanovsky_district_(Vladimir_Region).jpg',
  },
  {
    id: 'c3300016102',
    kind: 'coat',
    name: 'Администрация Собинского округа',
    logo: '/customers/coats/q617420.webp',
    width: 128,
    height: 160,
    source: 'https://commons.wikimedia.org/wiki/File:Coat_of_Arms_of_Sobinsky_rayon.png',
  },
  {
    id: 'c3324005050',
    kind: 'coat',
    name: 'Администрация Судогодского района',
    logo: '/customers/coats/q2702.webp',
    width: 160,
    height: 160,
    source: 'https://commons.wikimedia.org/wiki/File:Coat_of_arms_of_Vladimiri_Oblast.svg',
  },
  {
    id: 'c3329088660',
    kind: 'coat',
    name: 'Отдел по физической культуре и спорту Камешковского района',
    logo: '/customers/coats/q1652618.webp',
    width: 129,
    height: 160,
    source: 'https://commons.wikimedia.org/wiki/File:Coat_of_Arms_of_Kameshkovsky_rayon.png',
  },
  {
    id: 'c3316013957',
    kind: 'coat',
    name: 'Районный центр физической культуры и спорта «Киржач»',
    logo: '/customers/coats/q266987.webp',
    width: 129,
    height: 160,
    source:
      'https://commons.wikimedia.org/wiki/File:Coat_of_Arms_of_Kirzhachsky_rayon_(Vladimirskaya_oblast).png',
  },
  {
    id: 'c3323006809',
    kind: 'coat',
    name: 'Ставровский физкультурно-оздоровительный комплекс',
    logo: '/customers/coats/q617420.webp',
    width: 128,
    height: 160,
    source: 'https://commons.wikimedia.org/wiki/File:Coat_of_Arms_of_Sobinsky_rayon.png',
  },
  {
    id: 'c3309001358',
    kind: 'coat',
    name: 'Управление по культуре и спорту Собинского района',
    logo: '/customers/coats/q617420.webp',
    width: 128,
    height: 160,
    source: 'https://commons.wikimedia.org/wiki/File:Coat_of_Arms_of_Sobinsky_rayon.png',
  },
  {
    id: 'fok-gorokhovets',
    kind: 'logo',
    name: 'Физкультурно-оздоровительный комплекс им. В. Ф. Жукова, Гороховец',
    logo: '/customers/fok-gorokhovets.webp',
    width: 339,
    height: 240,
    source: 'https://www.fokgrh.ru/',
  },
  {
    id: 'c3338006618',
    kind: 'coat',
    name: 'Физкультурно-спортивный комплекс Вязниковского района',
    logo: '/customers/coats/q2218202.webp',
    width: 130,
    height: 160,
    source: 'https://commons.wikimedia.org/wiki/File:Vyaznikovskii_rayon_COA.gif',
  },
  {
    id: 'c3421002697',
    kind: 'coat',
    name: 'Администрация Аксайского сельского поселения',
    logo: '/customers/coats/q3881420.webp',
    width: 107,
    height: 160,
    source: 'https://commons.wikimedia.org/wiki/File:Coat_of_arms_of_Oktyabrsky_district_02.png',
  },
  {
    id: 'c3409100218',
    kind: 'coat',
    name: 'Администрация Калачевского района',
    logo: '/customers/coats/q1652841.webp',
    width: 108,
    height: 160,
    source:
      'https://commons.wikimedia.org/wiki/File:Coat_of_arms_of_Kalachyovsky_district_2007_01_(official).png',
  },
  {
    id: 'c3408009260',
    kind: 'coat',
    name: 'Администрация Качалинского сельского поселения',
    logo: '/customers/coats/q1652004.webp',
    width: 106,
    height: 160,
    source: 'https://commons.wikimedia.org/wiki/File:CoA_of_Ilovlinsky_district.png',
  },
  {
    id: 'c3415012760',
    kind: 'coat',
    name: 'Администрация Колобовского сельского поселения',
    logo: '/customers/coats/q3830180.webp',
    width: 130,
    height: 160,
    source: 'https://commons.wikimedia.org/wiki/File:Coat_of_arms_of_Leninsky_district_2005_01.png',
  },
  {
    id: 'c3418100239',
    kind: 'coat',
    name: 'Администрация Николаевского района',
    logo: '/customers/coats/q3876924.webp',
    width: 105,
    height: 160,
    source:
      'https://commons.wikimedia.org/wiki/File:Coat_of_arms_of_Nikolayevsky_district_2007_02.png',
  },
  {
    id: 'c3424021578',
    kind: 'coat',
    name: 'Кумылженская детско-юношеская спортивная школа',
    logo: '/customers/coats/q1652535.webp',
    width: 106,
    height: 160,
    source:
      'https://commons.wikimedia.org/wiki/File:Coat_of_arms_of_Kumylzhensky_district_2005_01.png',
  },
  {
    id: 'c3423011312',
    kind: 'coat',
    name: 'Отдел по делам молодёжи и спорту Палласовского района',
    logo: '/customers/coats/q1654848.webp',
    width: 107,
    height: 160,
    source:
      'https://commons.wikimedia.org/wiki/File:Coat_of_arms_of_Pallasovsky_district_2008_(official).png',
  },
  {
    id: 'c3430032105',
    kind: 'coat',
    name: 'Суровикинская спортивная школа',
    logo: '/customers/coats/q1655777.webp',
    width: 137,
    height: 160,
    source:
      'https://commons.wikimedia.org/wiki/File:Coat_of_arms_of_Surovikinsky_district_2017_without_a_crown.png',
  },
  {
    id: 'c3432001529',
    kind: 'coat',
    name: 'Центр культуры, молодёжной политики и спорта Фроловского района',
    logo: '/customers/coats/q600611.webp',
    width: 132,
    height: 160,
    source:
      'https://commons.wikimedia.org/wiki/File:Coat_of_arms_of_Frolovsky_district_2007_(official)_01.png',
  },
  {
    id: 'c3433006784',
    kind: 'coat',
    name: 'Чернышковская средняя школа № 2',
    logo: '/customers/coats/q1652041.webp',
    width: 107,
    height: 160,
    source:
      'https://commons.wikimedia.org/wiki/File:Coat_of_arms_of_Chernyshkovsky_district_with_a_crown_01.png',
  },
  {
    id: 'c3505005790',
    kind: 'coat',
    name: 'Администрация Верховажского округа',
    logo: '/customers/coats/q2217962.webp',
    width: 136,
    height: 160,
    source:
      'https://commons.wikimedia.org/wiki/File:Coat_of_Arms_of_Verkhovazhsky_rayon_(Vologda_oblast).png',
  },
  {
    id: 'c3506005337',
    kind: 'coat',
    name: 'Администрация Вожегодского округа',
    logo: '/customers/coats/q2218459.webp',
    width: 129,
    height: 160,
    source:
      'https://commons.wikimedia.org/wiki/File:Coat_of_Arms_of_Vozhegodskyj_rayon_(Vologda_oblast).png',
  },
  {
    id: 'c3526038690',
    kind: 'coat',
    name: 'Управление строительства и ЖКХ Великоустюгского округа',
    logo: '/customers/coats/q1658607.webp',
    width: 124,
    height: 160,
    source:
      'https://commons.wikimedia.org/wiki/File:Coat_of_Arms_of_Velikiy_Ustyug_(Vologda_oblast)_(2000).png',
  },
  {
    id: 'c3632002086',
    kind: 'coat',
    name: 'Администрация Эртильского района',
    logo: '/customers/coats/q4025627.webp',
    width: 128,
    height: 160,
    source:
      'https://commons.wikimedia.org/wiki/File:Coat_of_Arms_of_Ertil_rayon_(Voronezh_oblast).svg',
  },
  {
    id: 'c3629004622',
    kind: 'coat',
    name: 'Высоковская средняя школа',
    logo: '/customers/coats/q1655818.webp',
    width: 127,
    height: 160,
    source:
      'https://commons.wikimedia.org/wiki/File:Coat_of_Arms_of_Talovsky_rayon_(Voronezh_oblast).png',
  },
  {
    id: 'c3615003072',
    kind: 'coat',
    name: 'Нижнедевицкая гимназия',
    logo: '/customers/coats/q1653589.webp',
    width: 128,
    height: 160,
    source:
      'https://commons.wikimedia.org/wiki/File:Coat_of_Arms_of_Nizhnedevitsky_rayon_(Voronezh_Oblast).png',
  },
  {
    id: 'c3619006518',
    kind: 'coat',
    name: 'Острогожская спортивная школа',
    logo: '/customers/coats/q1653925.webp',
    width: 129,
    height: 160,
    source:
      'https://commons.wikimedia.org/wiki/File:Coat_of_Arms_of_Ostrogozhsky_rayon_(Voronezh_oblast).png',
  },
  {
    id: 'c3621004148',
    kind: 'coat',
    name: 'Панинская средняя школа',
    logo: '/customers/coats/q1884296.webp',
    width: 127,
    height: 160,
    source:
      'https://commons.wikimedia.org/wiki/File:Coat_of_Arms_of_Paninsky_rayon_(Voronezh_oblast).png',
  },
  {
    id: 'c3622004334',
    kind: 'coat',
    name: 'Петропавловская детско-юношеская спортивная школа',
    logo: '/customers/coats/q3901092.webp',
    width: 128,
    height: 160,
    source:
      'https://commons.wikimedia.org/wiki/File:Coat_of_Arms_of_Petropavlovsky_rayon_(Voronezh_oblast).png',
  },
  {
    id: 'c3625011139',
    kind: 'coat',
    name: 'Рамонский центр физической культуры и спорта',
    logo: '/customers/coats/q1654556.webp',
    width: 127,
    height: 160,
    source:
      'https://commons.wikimedia.org/wiki/File:Coat_of_Arms_of_Ramonsky_rayon_(Voronezh_oblast).png',
  },
  {
    id: 'c3610012490',
    kind: 'coat',
    name: 'Управление по физической культуре и спорту Калачеевского района',
    logo: '/customers/coats/q3812567.webp',
    width: 127,
    height: 160,
    source:
      'https://commons.wikimedia.org/wiki/File:Coat_of_Arms_of_Kalacheyevsky_rayon_(Voronezh_oblast).png',
  },
  {
    id: 'c3728013018',
    kind: 'coat',
    name: 'Департамент спорта Ивановской области',
    logo: '/customers/coats/q2654.webp',
    width: 229,
    height: 160,
    source: 'https://commons.wikimedia.org/wiki/File:Coat_of_Arms_of_Ivanovo_Oblast.svg',
  },
  {
    id: 'c3707003386',
    kind: 'coat',
    name: 'Старовичугская средняя школа им. Г. В. Писарева',
    logo: '/customers/coats/q2218553.webp',
    width: 133,
    height: 160,
    source: 'https://commons.wikimedia.org/wiki/File:Герб_Вичугского_района.jpg',
  },
  {
    id: 'c3819014548',
    kind: 'coat',
    name: 'Межпоселенческая библиотека Усольского района',
    logo: '/customers/coats/q4006638.webp',
    width: 129,
    height: 160,
    source:
      'https://commons.wikimedia.org/wiki/File:Coat_of_Arms_of_Usolsky_rayon_(Irkutsk_oblast).png',
  },
  {
    id: 'c3851005499',
    kind: 'coat',
    name: 'Центр развития физической культуры и спорта, Черемхово',
    logo: '/customers/coats/q23898958.webp',
    width: 128,
    height: 160,
    source:
      'https://commons.wikimedia.org/wiki/File:Coat_of_Arms_of_Cheremkhovo_(Irkutsk_oblast).png',
  },
  {
    id: 'c4230028230',
    kind: 'coat',
    name: 'Физкультурно-спортивный центр г. Юрги',
    logo: '/customers/coats/q27566181.webp',
    width: 127,
    height: 160,
    source: 'https://commons.wikimedia.org/wiki/File:Coat_of_Arms_of_Yurga_(Kemerovo_oblast).png',
  },
  {
    id: 'c4301002376',
    kind: 'coat',
    name: 'Администрация Арбажского округа',
    logo: '/customers/coats/q2640717.webp',
    width: 127,
    height: 160,
    source:
      'https://commons.wikimedia.org/wiki/File:Coat_of_Arms_of_Arbazhsky_rayon_(Kirov_oblast).png',
  },
  {
    id: 'c4346012960',
    kind: 'coat',
    name: 'Управление администрации Кирова по Ленинскому району',
    logo: '/customers/coats/q4221641.webp',
    width: 95,
    height: 160,
    source: 'https://commons.wikimedia.org/wiki/File:Coat_of_arms_of_Kirov.svg',
  },
  {
    id: 'c4416001259',
    kind: 'coat',
    name: 'Администрация Макарьевского округа',
    logo: '/customers/coats/q3843630.webp',
    width: 127,
    height: 160,
    source:
      'https://commons.wikimedia.org/wiki/File:Coat_of_Arms_of_Makariev_(Kostroma_oblast).png',
  },
  {
    id: 'c4424001213',
    kind: 'coat',
    name: 'Администрация Поназыревского округа',
    logo: '/customers/coats/q1653957.webp',
    width: 128,
    height: 160,
    source: 'https://commons.wikimedia.org/wiki/File:Coat_of_Arms_Ponazyrevo_(Kostroma_oblast).png',
  },
  {
    id: 'c4427000137',
    kind: 'coat',
    name: 'Администрация Судиславского района',
    logo: '/customers/coats/q1656139.webp',
    width: 128,
    height: 160,
    source:
      'https://commons.wikimedia.org/wiki/File:Coat_of_Arms_of_Sudislavl_rayon_(Kostroma_oblast).png',
  },
  {
    id: 'c4428002225',
    kind: 'coat',
    name: 'Администрация Сусанинского района',
    logo: '/customers/coats/q1655740.webp',
    width: 130,
    height: 160,
    source:
      'https://commons.wikimedia.org/wiki/File:Coat_of_Arms_of_Susanino_rayon_(Kostroma_oblast).png',
  },
  {
    id: 'c2335063711',
    kind: 'coat',
    name: 'Администрация Журавского сельского поселения',
    logo: '/customers/coats/q918606.webp',
    width: 127,
    height: 160,
    source:
      'https://commons.wikimedia.org/wiki/File:Coat_of_Arms_of_Korenovsk_rayon_(Krasnodar_krai).png',
  },
  {
    id: 'c2365004544',
    kind: 'coat',
    name: 'Администрация Небугского сельского поселения',
    logo: '/customers/coats/q261493.webp',
    width: 103,
    height: 160,
    source:
      'https://commons.wikimedia.org/wiki/File:Coat_of_Arms_of_Tuapse_rayon_(Krasnodar_krai).png',
  },
  {
    id: 'c2357003709',
    kind: 'coat',
    name: 'Администрация Успенского района',
    logo: '/customers/coats/q918593.webp',
    width: 125,
    height: 160,
    source:
      'https://commons.wikimedia.org/wiki/File:Coat_of_Arms_of_Uspensky_rayon_(Krasnodar_krai).png',
  },
  {
    id: 'patriot-kuban',
    kind: 'logo',
    name: 'Военно-патриотический центр «Патриот»',
    logo: '/customers/patriot-kuban.svg',
    width: 200,
    height: 60,
    source: 'https://patriot-kuban.ru/',
  },
  {
    id: 'c2310134390',
    kind: 'coat',
    name: 'Дирекция спортивных объектов, Краснодар',
    logo: '/customers/coats/q4307501.webp',
    width: 194,
    height: 160,
    source:
      'https://commons.wikimedia.org/wiki/File:Coat_of_Arms_of_Krasnodar_(Krasnodar_krai).png',
  },
  {
    id: 'c2345010973',
    kind: 'coat',
    name: 'Комитет по физической культуре и спорту Отрадненского района',
    logo: '/customers/coats/q925845.webp',
    width: 125,
    height: 160,
    source: 'https://commons.wikimedia.org/wiki/File:Coat_of_Otradnenskii_rayon.png',
  },
  {
    id: 'c2351012048',
    kind: 'coat',
    name: 'Отдел по физической культуре и спорту Тбилисского района',
    logo: '/customers/coats/q918129.webp',
    width: 126,
    height: 160,
    source: 'https://commons.wikimedia.org/wiki/File:Coat_of_Tbilisskii_rayon.png',
  },
  {
    id: 'c2346015822',
    kind: 'coat',
    name: 'Спортивная школа «Виктория», Павловский район',
    logo: '/customers/coats/q854601.webp',
    width: 130,
    height: 160,
    source: 'https://commons.wikimedia.org/wiki/File:Coat_of_Pavlovskii_rayon.png',
  },
  {
    id: 'c2350003202',
    kind: 'coat',
    name: 'Спортивная школа «Виктория», Староминский район',
    logo: '/customers/coats/q250512.webp',
    width: 128,
    height: 160,
    source: 'https://commons.wikimedia.org/wiki/File:Coat_of_Starominskii_rayon.png',
  },
  {
    id: 'c2315215532',
    kind: 'coat',
    name: 'Спортивная школа «Натухаевская», Новороссийск',
    logo: '/customers/coats/q3680.webp',
    width: 129,
    height: 160,
    source: 'https://commons.wikimedia.org/wiki/File:Coat_of_Arms_of_Krasnodar_Krai.svg',
  },
  {
    id: 'c2336009555',
    kind: 'coat',
    name: 'Спортивная школа «Олимпиец», Красноармейский район',
    logo: '/customers/coats/q918201.webp',
    width: 128,
    height: 160,
    source: 'https://commons.wikimedia.org/wiki/File:Coat_of_Krasnoarmeiskii_rayon.png',
  },
  {
    id: 'c2360000240',
    kind: 'coat',
    name: 'Спортивная школа «Чемпион», Новопокровский район',
    logo: '/customers/coats/q919023.webp',
    width: 127,
    height: 160,
    source: 'https://commons.wikimedia.org/wiki/File:Coat_of_Novopokrovskii_rayon.png',
  },
  {
    id: 'c2322015630',
    kind: 'coat',
    name: 'Средняя школа № 2 им. Б. М. Ляха, Туапсе',
    logo: '/customers/coats/q261493.webp',
    width: 103,
    height: 160,
    source:
      'https://commons.wikimedia.org/wiki/File:Coat_of_Arms_of_Tuapse_rayon_(Krasnodar_krai).png',
  },
  {
    id: 'c2320193429',
    kind: 'coat',
    name: 'Управление капитального строительства, Сочи',
    logo: '/customers/coats/q3085607.webp',
    width: 128,
    height: 160,
    source: 'https://commons.wikimedia.org/wiki/File:Coat_of_Arms_of_Sochi_(Krasnodar_krai).svg',
  },
  {
    id: 'c2315018559',
    kind: 'coat',
    name: 'Управление строительства, Новороссийск',
    logo: '/customers/coats/q3680.webp',
    width: 129,
    height: 160,
    source: 'https://commons.wikimedia.org/wiki/File:Coat_of_Arms_of_Krasnodar_Krai.svg',
  },
  {
    id: 'c2310103994',
    kind: 'coat',
    name: 'Центр развития спорта Краснодарского края',
    logo: '/customers/coats/q3680.webp',
    width: 129,
    height: 160,
    source: 'https://commons.wikimedia.org/wiki/File:Coat_of_Arms_of_Krasnodar_Krai.svg',
  },
  {
    id: 'c2408003812',
    kind: 'coat',
    name: 'Большемуртинская спортивная школа',
    logo: '/customers/coats/q6563.webp',
    width: 131,
    height: 160,
    source: 'https://commons.wikimedia.org/wiki/File:Coat_of_arms_of_Krasnoyarsk_Krai.svg',
  },
  {
    id: 'c2466215220',
    kind: 'coat',
    name: 'Управление капитального строительства Красноярского края',
    logo: '/customers/coats/q6563.webp',
    width: 131,
    height: 160,
    source: 'https://commons.wikimedia.org/wiki/File:Coat_of_arms_of_Krasnoyarsk_Krai.svg',
  },
  {
    id: 'c4512005150',
    kind: 'coat',
    name: 'Лебяжьевская средняя школа',
    logo: '/customers/coats/q1753203.webp',
    width: 129,
    height: 160,
    source:
      'https://commons.wikimedia.org/wiki/File:Coat_of_Arms_of_Lebyazhyevskiy_rayon_(Kurganskaya_oblast).gif',
  },
  {
    id: 'c4604004372',
    kind: 'coat',
    name: 'Администрация Горшеченского района',
    logo: '/customers/coats/q2629931.webp',
    width: 124,
    height: 160,
    source:
      'https://commons.wikimedia.org/wiki/File:Coat_of_Arms_of_Gorshechnoe_rayon_(Kursk_oblast).png',
  },
  {
    id: 'c4605005509',
    kind: 'coat',
    name: 'Администрация Дмитриевского района',
    logo: '/customers/coats/q2629937.webp',
    width: 127,
    height: 160,
    source: 'https://commons.wikimedia.org/wiki/File:Coat_of_Arms_of_Dmitriyev.svg',
  },
  {
    id: 'c4609003750',
    kind: 'coat',
    name: 'Администрация Конышевского района',
    logo: '/customers/coats/q2629989.webp',
    width: 124,
    height: 160,
    source:
      'https://commons.wikimedia.org/wiki/File:Coat_of_Arms_of_Konyshevka_rayon_(Kursk_oblast).png',
  },
  {
    id: 'c4611008057',
    kind: 'coat',
    name: 'Администрация Курского района',
    logo: '/customers/coats/q2387416.webp',
    width: 124,
    height: 160,
    source:
      'https://commons.wikimedia.org/wiki/File:Coat_of_Arms_of_Kursk_rayon_(Kursk_oblast).png',
  },
  {
    id: 'c4616006857',
    kind: 'coat',
    name: 'Администрация Обоянского района',
    logo: '/customers/coats/q3178.webp',
    width: 161,
    height: 160,
    source: 'https://commons.wikimedia.org/wiki/File:Coat_of_arms_of_Kursk_Oblast.svg',
  },
  {
    id: 'c4622902153',
    kind: 'coat',
    name: 'Администрация Солнцевского района',
    logo: '/customers/coats/q2629962.webp',
    width: 124,
    height: 160,
    source:
      'https://commons.wikimedia.org/wiki/File:Coat_of_Arms_of_Solntsevo_rayon_(Kursk_oblast).png',
  },
  {
    id: 'c4628003191',
    kind: 'coat',
    name: 'Администрация Щигровского района',
    logo: '/customers/coats/q2629594.webp',
    width: 128,
    height: 160,
    source: 'https://commons.wikimedia.org/wiki/File:Shchigry_rayon_COA_(2021).jpg',
  },
  {
    id: 'c4632154838',
    kind: 'coat',
    name: 'Спортивная школа бокса, Курск',
    logo: '/customers/coats/q3159.webp',
    width: 128,
    height: 160,
    source: 'https://commons.wikimedia.org/wiki/File:Kursk_city_COA.svg',
  },
  {
    id: 'c4703079940',
    kind: 'coat',
    name: 'Центр «Ладога», Ленинградская область',
    logo: '/customers/coats/q2191.webp',
    width: 140,
    height: 160,
    source: 'https://commons.wikimedia.org/wiki/File:Coat_of_arms_of_Leningrad_Oblast.svg',
  },
  {
    id: 'c4802001831',
    kind: 'coat',
    name: 'Администрация Грязинского района',
    logo: '/customers/coats/q2217621.webp',
    width: 127,
    height: 160,
    source: 'https://commons.wikimedia.org/wiki/File:Gryazi_rayon_Lipetsk.png',
  },
  {
    id: 'c4811002246',
    kind: 'coat',
    name: 'Администрация Лебедянского района',
    logo: '/customers/coats/q1653028.webp',
    width: 128,
    height: 160,
    source:
      'https://commons.wikimedia.org/wiki/File:Coat_of_Arms_of_Lebedyan_rayon_(Lipetsk_oblast).png',
  },
  {
    id: 'c4812000883',
    kind: 'coat',
    name: 'Администрация Лев-Толстовского района',
    logo: '/customers/coats/q2217246.webp',
    width: 127,
    height: 160,
    source:
      'https://commons.wikimedia.org/wiki/File:Coat_of_Arms_of_Lev-Tolstovsky_rayon_(Lipetsk_oblast).png',
  },
  {
    id: 'c4813003245',
    kind: 'coat',
    name: 'Администрация Липецкого района',
    logo: '/customers/coats/q2263898.webp',
    width: 128,
    height: 160,
    source:
      'https://commons.wikimedia.org/wiki/File:Coat_of_Arms_of_Lipetsk_rayon_(Lipetsk_oblast).png',
  },
  {
    id: 'c4818001450',
    kind: 'coat',
    name: 'Администрация Чаплыгинского района',
    logo: '/customers/coats/q1651493.webp',
    width: 128,
    height: 160,
    source:
      'https://commons.wikimedia.org/wiki/File:Coat_of_Arms_of_Chaplygin_(Lipetsk_oblast).png',
  },
  {
    id: 'c4804002189',
    kind: 'coat',
    name: 'Отдел культуры и спорта Добринского района',
    logo: '/customers/coats/q2217673.webp',
    width: 123,
    height: 160,
    source:
      'https://commons.wikimedia.org/wiki/File:Coat_of_Arms_of_Dobrinka_rayon_(Lipetsk_oblast).png',
  },
  {
    id: 'c4812004750',
    kind: 'coat',
    name: 'Отдел культуры и спорта Лев-Толстовского района',
    logo: '/customers/coats/q2217246.webp',
    width: 127,
    height: 160,
    source:
      'https://commons.wikimedia.org/wiki/File:Coat_of_Arms_of_Lev-Tolstovsky_rayon_(Lipetsk_oblast).png',
  },
  {
    id: 'c4814001346',
    kind: 'coat',
    name: 'Отдел культуры и спорта Становлянского округа',
    logo: '/customers/coats/q1655834.webp',
    width: 127,
    height: 160,
    source:
      'https://commons.wikimedia.org/wiki/File:Coat_of_Arms_of_Stanovlyansky_rayon_(Lipetsk_oblast).png',
  },
  {
    id: 'c4815006153',
    kind: 'coat',
    name: 'Тербунская детско-юношеская спортивная школа',
    logo: '/customers/coats/q1655801.webp',
    width: 127,
    height: 160,
    source:
      'https://commons.wikimedia.org/wiki/File:Coat_of_Arms_of_Terbunsky_rayon_(Lipetsk_oblast).png',
  },
  {
    id: 'c5004003890',
    kind: 'coat',
    name: 'Администрация Волоколамского округа',
    logo: '/customers/coats/q940875.webp',
    width: 124,
    height: 160,
    source:
      'https://commons.wikimedia.org/wiki/File:Coat_of_Arms_of_Volokolamsk_(Moscow_oblast).png',
  },
  {
    id: 'c5045066459',
    kind: 'coat',
    name: 'Управление благоустройства, Ступино',
    logo: '/customers/coats/q2723481.webp',
    width: 124,
    height: 160,
    source: 'https://commons.wikimedia.org/wiki/File:Coat_of_Arms_of_Stupino_(Moscow_oblast).png',
  },
  {
    id: 'c5007101960',
    kind: 'coat',
    name: 'Центр развития физической культуры, спорта и отдыха, Дмитров',
    logo: '/customers/coats/q1697.webp',
    width: 119,
    height: 160,
    source: 'https://commons.wikimedia.org/wiki/File:Coat_of_arms_of_Moscow_Oblast.svg',
  },
  {
    id: 'c5191501798',
    kind: 'coat',
    name: 'Министерство спорта Мурманской области',
    logo: '/customers/coats/q1759.webp',
    width: 132,
    height: 160,
    source:
      'https://commons.wikimedia.org/wiki/File:Coat_of_arms_of_Murmansk_Oblast_(large,_alternative).svg',
  },
  {
    id: 'c5260235162',
    kind: 'coat',
    name: '«Нижегородстройзаказчик»',
    logo: '/customers/coats/q2246.webp',
    width: 155,
    height: 160,
    source: 'https://commons.wikimedia.org/wiki/File:Coat_of_arms_of_Nizhny_Novgorod_Region.svg',
  },
  {
    id: 'c5260290572',
    kind: 'coat',
    name: 'Министерство спорта Нижегородской области',
    logo: '/customers/coats/q2246.webp',
    width: 155,
    height: 160,
    source: 'https://commons.wikimedia.org/wiki/File:Coat_of_arms_of_Nizhny_Novgorod_Region.svg',
  },
  {
    id: 'c5204012701',
    kind: 'coat',
    name: 'Центр развития физкультуры и спорта Большемурашкинского района',
    logo: '/customers/coats/q3266281.webp',
    width: 129,
    height: 160,
    source:
      'https://commons.wikimedia.org/wiki/File:Coat_of_Arms_of_Bolshemurashkinskiy_rayon_(Nizhny_Novgorod_oblast)_2012.gif',
  },
  {
    id: 'c5310011019',
    kind: 'coat',
    name: 'Служба заказчика по строительству и хозяйственному обеспечению',
    logo: '/customers/coats/q2610877.webp',
    width: 135,
    height: 160,
    source: 'https://commons.wikimedia.org/wiki/File:Coat_of_Arms_of_Novgorod_District.png',
  },
  {
    id: 'c5309006529',
    kind: 'coat',
    name: 'Спортивно-оздоровительный центр Мошенского района',
    logo: '/customers/coats/q2373743.webp',
    width: 100,
    height: 126,
    source: 'https://commons.wikimedia.org/wiki/File:NovMosensk_gerb.gif',
  },
  {
    id: 'c5316005220',
    kind: 'coat',
    name: 'Хвойнинский спортивно-молодёжный центр',
    logo: '/customers/coats/q2707123.webp',
    width: 120,
    height: 160,
    source: 'https://commons.wikimedia.org/wiki/File:Coat_of_Arms_of_Khvoyninsky_district.png',
  },
  {
    id: 'c5528025443',
    kind: 'coat',
    name: 'Спортивный комплекс «Сибирский», Омский район',
    logo: '/customers/coats/q5835.webp',
    width: 128,
    height: 160,
    source: 'https://commons.wikimedia.org/wiki/File:Coat_of_Arms_of_Omsk_Oblast.svg',
  },
  {
    id: 'c5622003542',
    kind: 'coat',
    name: 'Детско-юношеская спортивная школа Асекеевского района',
    logo: '/customers/coats/q3624930.webp',
    width: 135,
    height: 160,
    source: 'https://commons.wikimedia.org/wiki/File:Герб_Асекеевского_района.png',
  },
  {
    id: 'c5753061040',
    kind: 'coat',
    name: 'Департамент физической культуры и спорта Орловской области',
    logo: '/customers/coats/q3129.webp',
    width: 118,
    height: 160,
    source: 'https://commons.wikimedia.org/wiki/File:Coat_of_arms_of_Oryol_Oblast_(large).svg',
  },
  {
    id: 'c5918216588',
    kind: 'coat',
    name: 'Управление капитального строительства, Лысьва',
    logo: '/customers/coats/q971307.webp',
    width: 98,
    height: 160,
    source: 'https://commons.wikimedia.org/wiki/File:Coat_of_Arms_of_Lysva_(2012).gif',
  },
  {
    id: 'c0411014585',
    kind: 'coat',
    name: 'Управление ЖКХ администрации Горно-Алтайска',
    logo: '/customers/coats/q15190372.webp',
    width: 124,
    height: 160,
    source:
      'https://commons.wikimedia.org/wiki/File:Coat_of_Arms_of_Gornoaltaysk_(Altai_Republic)_1997.svg',
  },
  {
    id: 'c0608019083',
    kind: 'coat',
    name: 'Министерство по физической культуре и спорту Республики Ингушетия',
    logo: '/customers/coats/q5219.webp',
    width: 160,
    height: 160,
    source: 'https://commons.wikimedia.org/wiki/File:Coat_of_arms_of_Ingushetia.svg',
  },
  {
    id: 'c1102008890',
    kind: 'coat',
    name: 'Управление физической культуры и спорта, Ухта',
    logo: '/customers/coats/q2602523.webp',
    width: 126,
    height: 160,
    source: 'https://commons.wikimedia.org/wiki/File:Coat_of_Arms_of_Ukhta.svg',
  },
  {
    id: 'c1112007574',
    kind: 'coat',
    name: 'Центр спортивных мероприятий Прилузского района',
    logo: '/customers/coats/q1089793.webp',
    width: 128,
    height: 160,
    source: 'https://commons.wikimedia.org/wiki/File:Gerb-Priluzsky-region.gif',
  },
  {
    id: 'c9107004004',
    kind: 'coat',
    name: '«Городское хозяйство», Саки',
    logo: '/customers/coats/q15966495.webp',
    width: 143,
    height: 160,
    source: 'https://commons.wikimedia.org/wiki/File:Coat_of_arms_of_Crimea.svg',
  },
  {
    id: 'c9103082361',
    kind: 'coat',
    name: 'Спортивная школа «Авангард», Ялта',
    logo: '/customers/coats/q17627375.webp',
    width: 170,
    height: 160,
    source: 'https://commons.wikimedia.org/wiki/File:Coat_of_arms_of_Yalta.svg',
  },
  {
    id: 'c1211000629',
    kind: 'coat',
    name: 'Администрация Параньгинского района',
    logo: '/customers/coats/q40253.webp',
    width: 136,
    height: 160,
    source: 'https://commons.wikimedia.org/wiki/File:RUS_Параньгинский_район_COA.gif',
  },
  {
    id: 'c1326137309',
    kind: 'coat',
    name: 'Министерство спорта Республики Мордовия',
    logo: '/customers/coats/q5340.webp',
    width: 145,
    height: 160,
    source: 'https://commons.wikimedia.org/wiki/File:Coat_of_arms_of_Mordovia.svg',
  },
  {
    id: 'c6103600307',
    kind: 'coat',
    name: 'Администрация Багаевского сельского поселения',
    logo: '/customers/coats/q1778570.webp',
    width: 124,
    height: 160,
    source: 'https://commons.wikimedia.org/wiki/File:COA_of_Bagaevsky_rayon_(Rostov_oblast).gif',
  },
  {
    id: 'c6115902550',
    kind: 'coat',
    name: 'Администрация Кашарского сельского поселения',
    logo: '/customers/coats/q2217105.webp',
    width: 128,
    height: 160,
    source: 'https://commons.wikimedia.org/wiki/File:COA_of_Kasharsky_rayon_(Rostov_oblast).png',
  },
  {
    id: 'c6130002377',
    kind: 'coat',
    name: 'Администрация Родионово-Несветайского района',
    logo: '/customers/coats/q2220842.webp',
    width: 124,
    height: 160,
    source:
      'https://commons.wikimedia.org/wiki/File:Coat_of_Arms_of_Rodionovo-Nesvetaysky_District,_Rostov_Oblast_(2021).gif',
  },
  {
    id: 'c6117004248',
    kind: 'coat',
    name: 'Отдел культуры, спорта и туризма Куйбышевского района',
    logo: '/customers/coats/q3573.webp',
    width: 146,
    height: 160,
    source: 'https://commons.wikimedia.org/wiki/File:Coat_of_arms_of_Rostov_Oblast.svg',
  },
  {
    id: 'grebnoy-kanal-don',
    kind: 'logo',
    name: 'Спортивная школа «Гребной канал «Дон», Ростов-на-Дону',
    logo: '/customers/grebnoy-kanal-don.webp',
    width: 240,
    height: 240,
    source: 'https://grebnoykanal.ru/',
  },
  {
    id: 'sh-nika',
    kind: 'logo',
    name: 'Спортивная школа «Ника», Красный Сулин',
    logo: '/customers/sh-nika.webp',
    width: 152,
    height: 166,
    source: 'https://xn--80apbggiffilidmp.xn--p1ai/',
  },
  {
    id: 'sshor-35-rostov',
    kind: 'logo',
    name: 'Спортшкола олимпийского резерва № 35 им. братьев Самургашевых',
    logo: '/customers/sshor-35-rostov.webp',
    width: 422,
    height: 240,
    source: 'https://sdushor-35.ru/',
  },
  {
    id: 'c6138005193',
    kind: 'coat',
    name: 'Чертковская детско-юношеская спортивная школа',
    logo: '/customers/coats/q3573.webp',
    width: 146,
    height: 160,
    source: 'https://commons.wikimedia.org/wiki/File:Coat_of_arms_of_Rostov_Oblast.svg',
  },
  {
    id: 'c6234181226',
    kind: 'coat',
    name: 'Управление капитального строительства Рязанской области',
    logo: '/customers/coats/q2753.webp',
    width: 153,
    height: 160,
    source: 'https://commons.wikimedia.org/wiki/File:Coat_of_arms_of_Ryazan_Oblast.svg',
  },
  {
    id: 'c6452131987',
    kind: 'coat',
    name: 'Управление капитального строительства Саратовской области',
    logo: '/customers/coats/q5334.webp',
    width: 93,
    height: 160,
    source: 'https://commons.wikimedia.org/wiki/File:Coat_of_Arms_of_Saratov_oblast.svg',
  },
  {
    id: 'c6661004358',
    kind: 'coat',
    name: 'Детский оздоровительный центр «Юность Урала»',
    logo: '/customers/coats/q5462.webp',
    width: 216,
    height: 160,
    source: 'https://commons.wikimedia.org/wiki/File:Coat_of_Arms_of_Sverdlovsk_oblast.svg',
  },
  {
    id: 'c6718000907',
    kind: 'coat',
    name: 'Комитет по культуре и спорту Хиславичского округа',
    logo: '/customers/coats/q2708307.webp',
    width: 99,
    height: 160,
    source: 'https://commons.wikimedia.org/wiki/File:Khislavichskiy_rayon_COA_(2018).jpg',
  },
  {
    id: 'c6720003856',
    kind: 'coat',
    name: 'Шумячская централизованная клубная система',
    logo: '/customers/coats/q2638874.webp',
    width: 127,
    height: 160,
    source: 'https://commons.wikimedia.org/wiki/File:Shumyachskiy_rayon_COA_(2016).jpg',
  },
  {
    id: 'c2602005433',
    kind: 'coat',
    name: 'Апанасенковский районный стадион',
    logo: '/customers/coats/q1255190.webp',
    width: 133,
    height: 160,
    source: 'https://commons.wikimedia.org/wiki/File:Gerb_Apanasenkovskogo_raiona.png',
  },
  {
    id: 'c2636803695',
    kind: 'coat',
    name: 'Министерство физической культуры и спорта Ставропольского края',
    logo: '/customers/coats/q5207.webp',
    width: 136,
    height: 160,
    source: 'https://commons.wikimedia.org/wiki/File:Coat_of_arms_of_Stavropol_Krai.svg',
  },
  {
    id: 'kislovodsk-park',
    kind: 'logo',
    name: 'Национальный парк «Кисловодский»',
    logo: '/customers/kislovodsk-park.svg',
    width: 130,
    height: 31,
    source: 'https://kispark.ru/',
  },
  {
    id: 'c2609800060',
    kind: 'coat',
    name: 'Спортивно-культурный центр «Каскад», Новопавловск',
    logo: '/customers/coats/q2429108.webp',
    width: 130,
    height: 160,
    source: 'https://commons.wikimedia.org/wiki/File:Coat_of_Arms_of_Kirovskii_rayon.png',
  },
  {
    id: 'c2613008806',
    kind: 'coat',
    name: 'Спортивно-оздоровительный комплекс «Юность», Левокумское',
    logo: '/customers/coats/q1255230.webp',
    width: 131,
    height: 160,
    source:
      'https://commons.wikimedia.org/wiki/File:Coat_of_Arms_of_Levokumsky_rayon_(Stavropol_krai).png',
  },
  {
    id: 'c6921000774',
    kind: 'coat',
    name: 'Администрация Жарковского округа',
    logo: '/customers/coats/q2217934.webp',
    width: 128,
    height: 160,
    source:
      'https://commons.wikimedia.org/wiki/File:Coat_of_Arms_of_Zharkovsky_rayon_(Tver_oblast).png',
  },
  {
    id: 'c6942001000',
    kind: 'coat',
    name: 'Администрация Старицкого района',
    logo: '/customers/coats/q394622.webp',
    width: 130,
    height: 160,
    source: 'https://commons.wikimedia.org/wiki/File:Coat_of_Arms_of_Staritsa_(Tver_oblast).png',
  },
  {
    id: 'c6909010381',
    kind: 'coat',
    name: 'Комитет по культуре и спорту Кашинского округа',
    logo: '/customers/coats/q368518.webp',
    width: 128,
    height: 160,
    source: 'https://commons.wikimedia.org/wiki/File:Coat_of_Arms_of_Kashin_(Tver_oblast).png',
  },
  {
    id: 'c7302042874',
    kind: 'coat',
    name: 'Спортивная школа «Лада», Димитровград',
    logo: '/customers/coats/q5634.webp',
    width: 169,
    height: 160,
    source: 'https://commons.wikimedia.org/wiki/File:Герб_Ульяновской_области_(2013).svg',
  },
  {
    id: 'avangard-ulyanovsk',
    kind: 'logo',
    name: 'Центр патриотического воспитания «Авангард», Ульяновская область',
    logo: '/customers/avangard-ulyanovsk.webp',
    width: 296,
    height: 240,
    source: 'https://avangard73.su/',
  },
  {
    id: 'c8613002594',
    kind: 'coat',
    name: 'Администрация Березовского района',
    logo: '/customers/coats/q558713.webp',
    width: 128,
    height: 160,
    source:
      'https://commons.wikimedia.org/wiki/File:Coat_of_Arms_of_Beryozovsky_rayon_(Khanty-Mansyisky_AO).png',
  },
  {
    id: 'c8601003240',
    kind: 'coat',
    name: 'Депспорт Югры',
    logo: '/customers/coats/q6320.webp',
    width: 175,
    height: 160,
    source: 'https://commons.wikimedia.org/wiki/File:Coat_of_arms_of_Yugra_(Khanty-Mansia).svg',
  },
  {
    id: 'c7440005690',
    kind: 'coat',
    name: 'Комитет по физической культуре и спорту Увельского района',
    logo: '/customers/coats/q1658596.webp',
    width: 128,
    height: 160,
    source: 'https://commons.wikimedia.org/wiki/File:RUS_Увельский_район_COA.gif',
  },
  {
    id: 'c7612022525',
    kind: 'coat',
    name: 'Спортивная школа «Спарт», Углич',
    logo: '/customers/coats/q2218114.webp',
    width: 123,
    height: 160,
    source: 'https://commons.wikimedia.org/wiki/File:Coat_of_Arms_of_Uglich_(Yaroslavl_oblast).png',
  },
  {
    id: 'c7731486290',
    kind: 'coat',
    name: '«Жилищник района Кунцево», Москва',
    logo: '/customers/coats/q649.webp',
    width: 135,
    height: 160,
    source: 'https://commons.wikimedia.org/wiki/File:Coat_of_arms_of_Moscow.svg',
  },
  {
    id: 'c7733048623',
    kind: 'coat',
    name: 'Московская гандбольная академия',
    logo: '/customers/coats/q649.webp',
    width: 135,
    height: 160,
    source: 'https://commons.wikimedia.org/wiki/File:Coat_of_arms_of_Moscow.svg',
  },
  {
    id: 'c7807016241',
    kind: 'coat',
    name: 'Спортивная школа Красносельского района Санкт-Петербурга',
    logo: '/customers/coats/q656.webp',
    width: 149,
    height: 160,
    source: 'https://commons.wikimedia.org/wiki/File:Coat_of_arms_of_Saint_Petersburg_(2003).svg',
  },
  {
    id: 'c7811067633',
    kind: 'coat',
    name: 'Спортшкола олимпийского резерва № 2, Санкт-Петербург',
    logo: '/customers/coats/q656.webp',
    width: 149,
    height: 160,
    source: 'https://commons.wikimedia.org/wiki/File:Coat_of_arms_of_Saint_Petersburg_(2003).svg',
  },
];
